import React from "react";
import FaceRateSlider from "./FaceSliderBar";
import RateProgressBar from "./RateProgressBar";
import { useSelector } from "react-redux";
import useTheme from "../../hooks/useTheme";
import { AppColumn, AppRow } from "./Layouts";
import AppText from "../UI/Texts/AppTexts";
import { SizedBox } from "./Sizes";
import { getLocale } from "../../utils/helperFunctions";
import { t } from "i18next";

const WorkplaceInsightDetailCard = ({ workPlace, width }) => {
    const theme = useTheme();

    const scoringSystem = useSelector((state) => state.core.scoringSystem) ?? {};
    const scoringConfig = createWorkplaceScoringConfigFromMap(scoringSystem, getLocale())

    const categories = scoringConfig.categories;

    const assessmentScore = parseFloat(workPlace.insightsAssessment?.score || 0);

    return (
        <AppColumn >
            <AppText.BodyText margins={{ marginBottom: '0px' }} fontWeight={600}>{t('jobdetail.insights_from_employees')}</AppText.BodyText>
            <SizedBox height={theme.spacing.elementPadding} />
            <AppRow mainAxisAlignment={"space-between"}>
                <FaceRateSlider rate={assessmentScore} width={110} height={20} iconSize={40} />
                <AppText.BodyText fontWeight={600}>{assessmentScore.toFixed(2)}</AppText.BodyText >
            </AppRow>
            <SizedBox height={theme.spacing.contentElementPadding} />
            {Object.entries(categories).map(([key, category]) => {
                if (category.active) {
                    const average = parseFloat(workPlace.insightsAssessment[key] || 0);
                    return (
                        <RateProgressBar
                            key={key}
                            title={category.value}
                            average={average}
                            total={5}
                        />
                    );
                }
                return null;
            })}
        </AppColumn>
    );
};

export default WorkplaceInsightDetailCard;

const createVAPair = (value, active, index) => ({
    value,
    active,
    index,
});

const createVAPairFromMap = (map, languageCode = "en") => {
    const valueVariants = map.valueVariants || {};
    return createVAPair(
        valueVariants[languageCode] || map.value,
        map.active,
        map.index
    );
};

const createWorkplaceScoringConfig = (categories, questions) => ({
    categories,
    questions,
});

const createWorkplaceScoringConfigFromMap = (map, languageCode = "en") => {
    const categories = Object.entries(map.categories || {}).reduce(
        (acc, [key, value]) => {
            acc[key] = createVAPairFromMap(value, languageCode);
            return acc;
        },
        {}
    );

    const questions = Object.entries(map.questions || {}).reduce(
        (acc, [key, value]) => {
            acc[key] = Object.entries(value).reduce((nestedAcc, [nestedKey, nestedValue]) => {
                nestedAcc[nestedKey] = createVAPairFromMap(nestedValue, languageCode);
                return nestedAcc;
            }, {});
            return acc;
        },
        {}
    );

    return createWorkplaceScoringConfig(categories, questions);
};
